import { Page, ActivityCard } from '@/components';
import HistoricTabs from './HistoricTabs';

export default function OverallActivityPage() {
  return (
    <Page title="Activity">
      <HistoricTabs />
      <ActivityCard
        url="/overall/activity/"
        linkTo="events"
        onClickUrl="events"
      />
    </Page>
  );
}
